module.exports = __webpack_public_path__ + "img/10-r.82e44db8.png";